import { render } from "./TransactionsDetail.vue?vue&type=template&id=4cdae15e&scoped=true"
import script from "./TransactionsDetail.vue?vue&type=script&lang=js"
export * from "./TransactionsDetail.vue?vue&type=script&lang=js"

import "./TransactionsDetail.vue?vue&type=style&index=0&id=4cdae15e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cdae15e"]])

export default __exports__